export default __webpack_public_path__ + "static/media/landing-logo-white.8ad3c024.svg";